var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMingcuteSendLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7333 10.0176L9.22195 17.606L16.3884 21.6526L22.7075 15.486C23.0281 15.1735 23.4628 14.998 23.9159 14.9981C24.3691 14.9983 24.8036 15.1741 25.124 15.4868C25.4443 15.7995 25.6242 16.2236 25.624 16.6657C25.6238 17.1078 25.4437 17.5318 25.1231 17.8443L18.8023 24.011L22.9535 31.001L30.7333 10.0176ZM31.2851 6.27763C33.3265 5.55596 35.3048 7.48596 34.5651 9.47763L25.5417 33.8193C24.8002 35.816 22.0054 36.0593 20.9138 34.221L15.4181 24.9576L5.92315 19.596C4.03886 18.531 4.28828 15.8043 6.33486 15.081L31.2851 6.27763Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteSendLine);
export default __webpack_public_path__ + "static/media/mingcute_send-line.4184d4b2a9f36466ae11b25cd180c7d8.svg";
export { ForwardRef as ReactComponent };